const UPDATE_PREDICTIONS_REQUEST = 'address/UPDATE_PREDICTIONS_REQUEST'
const UPDATE_PREDICTIONS_SUCCESS = 'address/UPDATE_PREDICTIONS_SUCCESS'

const GET_ADDRESS_LOCATION_REQUEST = 'address/GET_ADDRESS_LOCATION_REQUEST'
const GET_ADDRESS_LOCATION_SUCCESS = 'address/GET_ADDRESS_LOCATION_SUCCESS'

const INITIAL_VALUES = {
  sessiontoken: null,
  predictions: [],
}

export default function reducer(state = INITIAL_VALUES, action) {
  switch (action.type) {
    case UPDATE_PREDICTIONS_SUCCESS:
      return {
        ...state,
        sessiontoken: action.sessiontoken,
        predictions: [...action.predictions],
      }
    case GET_ADDRESS_LOCATION_SUCCESS:
      return {
        ...state,
        sessiontoken: null,
      }
    default:
      return state
  }
}

function updatePredictionsRequest(address) {
  return {
    type: UPDATE_PREDICTIONS_REQUEST,
    address,
  }
}

function updatePredictionsSuccess(predictions, sessiontoken) {
  return {
    type: UPDATE_PREDICTIONS_SUCCESS,
    predictions,
    sessiontoken,
  }
}

function getAddressLocationRequest(address) {
  return {
    type: GET_ADDRESS_LOCATION_REQUEST,
    address,
  }
}

function getAddressLocationSuccess() {
  return {
    type: GET_ADDRESS_LOCATION_SUCCESS,
  }
}

const types = {
  UPDATE_PREDICTIONS_REQUEST,
  UPDATE_PREDICTIONS_SUCCESS,
  GET_ADDRESS_LOCATION_REQUEST,
  GET_ADDRESS_LOCATION_SUCCESS,
}

const actions = {
  updatePredictionsRequest,
  updatePredictionsSuccess,
  getAddressLocationRequest,
  getAddressLocationSuccess,
}

export { types, actions }
